import { isKey } from './type-helpers';

const APP_URL = {
  whatsapp: 'https://api.whatsapp.com/',
  telegram: 'https://webk.telegram.org/',
  teams: 'https://teams.microsoft.com/',
  gmail: 'https://mail.google.com/',
  evernote: 'https://www.evernote.com/',
  onenote: 'https://www.onenote.com/',
  onedrive: 'https://onedrive.live.com/',
  googledrive: 'https://drive.google.com/',
  'telegram (public)': 'https://drive.google.com/',
  ft: 'https://www.ft.com/',
  wsj: 'https://www.wsj.com/',
  economist: 'https://www.economist.com/',
  'ftalphaville.ft': 'https://ftalphaville.ft.com/',
  'krugman.blogs.nytimes': 'https://krugman.blogs.nytimes.com/',
  nakedcapitalism: 'https://www.nakedcapitalism.com/',
  valueinvestingworld: 'https://www.valueinvestingworld.com/',
  valuepickr: 'https://forum.valuepickr.com/',
  'economictimes.indiatimes': 'https://economictimes.indiatimes.com/',
  bloombergquint: 'https://www.bloombergquint.com/',
  livemint: 'https://www.livemint.com/',
  'business-standard': 'https://www.business-standard.com/',
  thehindubusinessline: 'https://www.thehindubusinessline.com/',
  drvijaymalik: 'https://www.drvijaymalik.com/',
  'sec.gov': 'https://www.sec.gov/',
  'sebi.gov': 'https://www.sebi.gov.in/',
  'fasb.org': 'https://www.fasb.org/',
  pcaobus: 'https://pcaobus.org/',
  fred: 'https://alfred.stlouisfed.org/',
  reddit: 'https://www.reddit.com/',
  bse_annual_reports: 'https://www.bseindia.com/',
  bse_annualreports: 'https://www.bseindia.com/',
  bse_filings: 'https://www.bseindia.com/',
  bse_presentations: 'https://www.bseindia.com/',
  bse_sdd_sast: 'https://www.bseindia.com/',
  crisil: 'https://www.crisilratings.com/',
  nzx_filings: 'https://www.nzx.com/',
};

export const getAppUrl = (source?: string) => {
  if (!source) {
    return '';
  }
  if (isKey(source, APP_URL)) {
    return APP_URL[source];
  }
  return '';
};
